import { InteractionManagementStatusType } from '@bus/models';
import { ContactOption, DataStorageData } from '../../shared/types';
import { JOURNEY_STATE } from '../App.state';
import { Step } from '../../shared/interface';



function mapToJourneyStatus(
  interactionManagementStatus?: InteractionManagementStatusType | string
) {
  switch (interactionManagementStatus) {
    case InteractionManagementStatusType.MATCHMAKER_VEHICLE_ANSWERED:
      return JOURNEY_STATE.FINANCING;
    case InteractionManagementStatusType.MATCHMAKER_FINANCIALS_ANSWERED:
    case InteractionManagementStatusType.MATCHMAKER_EQUIPMENT_ANSWERED:
    case InteractionManagementStatusType.MATCHMAKER_ENGINE_ANSWERED:
      return JOURNEY_STATE.DEALER_SELECTION;
    case InteractionManagementStatusType.DEALER_SELECTED:
      return JOURNEY_STATE.CONTACT_DETAILS;
    case InteractionManagementStatusType.PERSONALDETAILS_ENTERED:
      return JOURNEY_STATE.SUMMARY;
    case InteractionManagementStatusType.PREFERENCES_SUBMITTED:
      return JOURNEY_STATE.CONFIRMATION;
    default:
      return JOURNEY_STATE.STARTED;
  }
}

export function mapDataStorageDataToFormikState(dataStorageData: DataStorageData) {
  const bffEmails = dataStorageData?.customerData?.contactData?.emails;

  return {
    ...(dataStorageData?.customerData?.preferences ? {
      matchMakerAnswers: {
        condition: dataStorageData?.customerData?.preferences[0]?.conditions,
        typeOfCar: dataStorageData?.customerData?.preferences[0]?.bodyTypes,
        typeOfGears: dataStorageData?.customerData?.preferences[0]?.transmissions,
        fuelTypes: dataStorageData?.customerData?.preferences[0]?.fuelTypes,
        expectedDuration: dataStorageData?.customerData?.preferences[0]?.duration?.value,
        expectedMonthlyPayment:
          dataStorageData?.customerData?.preferences[0]?.budget?.to?.grossAmount,
        milesPerYear: dataStorageData?.customerData?.preferences[0]?.mileage?.value || 10000,
        modelOfCar: dataStorageData?.customerData?.preferences[0]?.modelDescriptions,
        specialEquipments: dataStorageData?.customerData?.preferences[0]?.options?.map(
          (e: { name: string }) => e.name
        ),
        additionalServices: dataStorageData?.customerData?.preferences[0]?.services?.map(
          (e: { name: string }) => e.name
        ),
        financePlan: dataStorageData?.customerData?.preferences[0]?.financialProducts,
        additionalDeposit: dataStorageData?.customerData?.preferences[0]?.deposit?.grossAmount,
        noAdditionalDepositCheckbox: dataStorageData?.customerData?.preferences[0]?.noAdditionalDepositCheckbox,
        minPower: dataStorageData?.customerData?.preferences[0]?.powerRange?.fromValue,
        maxPower: dataStorageData?.customerData?.preferences[0]?.powerRange?.toValue,
        additionalCustomerInformation: dataStorageData?.custom?.additionalInformation
      }
    } : {}),
    customerInformation: {
      firstName: dataStorageData?.customerData?.firstName ?? '',
      lastName: dataStorageData?.customerData?.lastName ?? '',
      phoneNumber:
        dataStorageData?.customerData?.contactData?.telephoneNumber
        ?? '',
      email: Array.isArray(bffEmails)
        ? bffEmails.map((e: { emailAddress: string }) => e.emailAddress).join(', ')
        : '',
      contactPreference:
        dataStorageData?.customerData?.preferredCommunicationChannel || ContactOption.EMAIL
    },
    currentJourneyStatus: mapToJourneyStatus(dataStorageData?.transaction?.interactionManagementStatus)
  };
}

export function mapToJourneyStep(interactionManagementStatus: InteractionManagementStatusType) {
  switch (interactionManagementStatus) {
    case InteractionManagementStatusType.MATCHMAKER_VEHICLE_ANSWERED:
      return Step.MM1;
    case InteractionManagementStatusType.MATCHMAKER_FINANCIALS_ANSWERED:
    case InteractionManagementStatusType.MATCHMAKER_EQUIPMENT_ANSWERED:
    case InteractionManagementStatusType.MATCHMAKER_ENGINE_ANSWERED:
      return Step.MM2;
    case InteractionManagementStatusType.DEALER_SELECTED:
      return Step.DEALER_SELECTION;
    case InteractionManagementStatusType.PERSONALDETAILS_ENTERED:
      return Step.CONTACT_DETAILS;
    case InteractionManagementStatusType.PREFERENCES_SUBMITTED:
      return Step.FINAL_CONFIRMATION;
    default:
      return null;
  }
}
